export class PendingsAop {
  protected pendings: number = 0;
  protected errors: number = 0;

  public get empty() { return this.pendings === 0; }
  public get busy() { return this.pendings !== 0; }
  public get error() { return this.errors > 0; }
  public async track(fn: Function) {
    try {
      this.pendings++;
      return await fn();
    } catch (e) {
      this.errors++;
      throw e;
    } finally {
      // could have been released and thus already be at 0
      this.pendings > 0 && this.pendings--;
    }
  }
  public setBusy() {
    this.pendings++;
  }
  public release() {
    this.pendings--;
  }
  public clear() {
    this.pendings = 0;
    this.errors = 0;
  }
}

// export function $pendings<T extends Record<string, PendingsAop>>(opts: T): T & {busy: boolean, empty: boolean} {
//   const keys = Object.keys(opts);
//   return {
//     ...opts,
//     get empty() { return Object.entries<PendingsAop>(this).filter(([k]) => keys.includes(k)).every(([_, p]) => p.empty); },
//     get busy() { return Object.entries<PendingsAop>(this).filter(([k]) => keys.includes(k)).some(([_, p]) => p.busy); }
//   }
// }
